import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { environment } from '../../../environments/environment';
import { DaveMutationChangeGeneratedDocumentsArgs, DocumentUserType, FilesType } from '../graphql-types';
import { BackendDateTimestamp } from '../helper/backend-frontend-conversion.helper';
import { DocumentUserEntity, DocumentUserEntityFromBackend, DocumentUserEntityGateway } from "./document-user.entity";
import {
    FileVersionTypeFromFileBackend,
    VersionEntity,
    VersionEntityFromLegacyBackend,
    VersionEntityFromFileBackend, VersionEntityFromBackend
} from "./version.entity";
import { Document, GetTimeFromTimestamp } from '@dave/types';
import { mimeTypes, mimeTypesMap } from '../helper/mime-types';
export interface UploadFileArgs {
    file: Blob;
    documentId?: number;
    description?: string;
    name?: string;
    customerIds?: number[];
    commissionIds?: number[];
    transmissionIds?: number[];
    tagIds?: number[];
    hidden?: boolean;
    eventIds?: number[];
}
export enum FileEntityDocumentTypes {
    invoice = 'invoice',
    offer = 'offer',
    contract = 'contract',
    order = 'order',
    assignment = 'assignment',
    delivery_note = 'delivery_note',
    assessment = 'assessment',
    order_confirmation = 'order_confirmation',
    protocol = 'protocol',
    audit_report = 'audit_report',
    blueprint = 'blueprint',
}

export interface FileMetaData {
    document_type?: FileEntityDocumentTypes;
    constructionDiaryIds?: number[];
    email?: {
        cid: string;
    };
    isInComment?: boolean;
    isCalendarFromEventId?: number;
}

export enum FileEntityDocumentType {
    Invoice = 'invoice',
    Offer = 'offer',
    Contract = 'contract',
    Order = 'order',
    Assignment = 'assignment',
    Delivery_note = 'delivery_note',
    Assessment = 'assessment',
    Order_confirmation = 'order_confirmation',
    Protocol = 'protocol',
    Audit_report = 'audit_report',
}
export enum DocumentState {
    DocumentStateNew = "DocumentStateNew",
    DocumentStateSigned = "DocumentStateSigned",
    DocumentStateEditing = "DocumentStateEditing",
    DocumentStateSend = "DocumentStateSend",
    DocumentStateConfirmed = "DocumentStateConfirmed",
    DocumentStateBooked = "DocumentStateBooked",
    DocumentStateCharged = "DocumentStateCharged",
    DocumentStateApproved = "DocumentStateApproved",
    DocumentStateInRelease = "DocumentStateInRelease",
    DocumentStateReleased = "DocumentStateReleased",
    DocumentStateCanceled = "DocumentStateCanceled"
}
export enum DocumentStateFromGql {

    Approved = 'Approved',
    Booked = 'Booked',
    Canceled = 'Canceled',
    Charged = 'Charged',
    Confirmed = 'Confirmed',
    Editing = 'Editing',
    InRelease = 'InRelease',
    New = 'New',
    Released = 'Released',
    Send = 'Send',
    Signed = 'Signed',
}
export enum DocumentStateFromFileBackend {
    DocumentStateNew = "new",
    DocumentStateSigned = "signed",
    DocumentStateEditing = "editing",
    DocumentStateSend = "send",
    DocumentStateConfirmed = "confirmed",
    DocumentStateBooked = "booked",
    DocumentStateCharged = "charged",
    DocumentStateApproved = "approved",
    DocumentStateInRelease = "in_release",
    DocumentStateReleased = "released",
    DocumentStateCanceled = "canceled",
}
const gqlDocumentStateDocumentState: Map<DocumentStateFromGql, DocumentState> = new Map<DocumentStateFromGql, DocumentState>([
    [DocumentStateFromGql.New, DocumentState.DocumentStateNew ],
    [DocumentStateFromGql.Signed, DocumentState.DocumentStateSigned ],
    [DocumentStateFromGql.Editing, DocumentState.DocumentStateEditing ],
    [DocumentStateFromGql.Send, DocumentState.DocumentStateSend ],
    [DocumentStateFromGql.Confirmed, DocumentState.DocumentStateConfirmed ],
    [DocumentStateFromGql.Booked, DocumentState.DocumentStateBooked ],
    [DocumentStateFromGql.Charged, DocumentState.DocumentStateCharged ],
    [DocumentStateFromGql.Approved, DocumentState.DocumentStateApproved ],
    [DocumentStateFromGql.InRelease, DocumentState.DocumentStateInRelease ],
    [DocumentStateFromGql.Released, DocumentState.DocumentStateReleased ],
    [DocumentStateFromGql.Canceled, DocumentState.DocumentStateCanceled ],
])
const documentStateGqlDocumentState: Map<DocumentState, DocumentStateFromGql> = new Map<DocumentState, DocumentStateFromGql>([
    [DocumentState.DocumentStateNew, DocumentStateFromGql.New ],
    [DocumentState.DocumentStateSigned, DocumentStateFromGql.Signed ],
    [DocumentState.DocumentStateEditing, DocumentStateFromGql.Editing ],
    [DocumentState.DocumentStateSend, DocumentStateFromGql.Send ],
    [DocumentState.DocumentStateConfirmed, DocumentStateFromGql.Confirmed ],
    [DocumentState.DocumentStateBooked, DocumentStateFromGql.Booked ],
    [DocumentState.DocumentStateCharged, DocumentStateFromGql.Charged ],
    [DocumentState.DocumentStateApproved, DocumentStateFromGql.Approved ],
    [DocumentState.DocumentStateInRelease, DocumentStateFromGql.InRelease ],
    [DocumentState.DocumentStateReleased, DocumentStateFromGql.Released ],
    [DocumentState.DocumentStateCanceled, DocumentStateFromGql.Canceled ],
])

export const getDocumentStateFromGQLDocumentState = (v: FilesType['state']): DocumentState => {
    return gqlDocumentStateDocumentState.get(v as unknown as DocumentStateFromGql);
}
export const getGQLDocumentStateFromDocumentState = (v: DocumentState): FilesType['state'] => {
    return documentStateGqlDocumentState.get(v) as unknown as FilesType['state'];
}



const fileBackendDocumentStateDocumentState: Map<DocumentStateFromFileBackend, DocumentState> = new Map<DocumentStateFromFileBackend, DocumentState>([
    [DocumentStateFromFileBackend.DocumentStateNew, DocumentState.DocumentStateNew ],
    [DocumentStateFromFileBackend.DocumentStateSigned, DocumentState.DocumentStateSigned ],
    [DocumentStateFromFileBackend.DocumentStateEditing, DocumentState.DocumentStateEditing ],
    [DocumentStateFromFileBackend.DocumentStateSend, DocumentState.DocumentStateSend ],
    [DocumentStateFromFileBackend.DocumentStateConfirmed, DocumentState.DocumentStateConfirmed ],
    [DocumentStateFromFileBackend.DocumentStateBooked, DocumentState.DocumentStateBooked ],
    [DocumentStateFromFileBackend.DocumentStateCharged, DocumentState.DocumentStateCharged ],
    [DocumentStateFromFileBackend.DocumentStateApproved, DocumentState.DocumentStateApproved ],
    [DocumentStateFromFileBackend.DocumentStateInRelease, DocumentState.DocumentStateInRelease ],
    [DocumentStateFromFileBackend.DocumentStateReleased, DocumentState.DocumentStateReleased ],
    [DocumentStateFromFileBackend.DocumentStateCanceled, DocumentState.DocumentStateCanceled ],
])
const documentStateFileBackendDocumentState: Map<DocumentState, DocumentStateFromFileBackend> = new Map<DocumentState, DocumentStateFromFileBackend>([
    [DocumentState.DocumentStateNew, DocumentStateFromFileBackend.DocumentStateNew ],
    [DocumentState.DocumentStateSigned, DocumentStateFromFileBackend.DocumentStateSigned ],
    [DocumentState.DocumentStateEditing, DocumentStateFromFileBackend.DocumentStateEditing ],
    [DocumentState.DocumentStateSend, DocumentStateFromFileBackend.DocumentStateSend ],
    [DocumentState.DocumentStateConfirmed, DocumentStateFromFileBackend.DocumentStateConfirmed ],
    [DocumentState.DocumentStateBooked, DocumentStateFromFileBackend.DocumentStateBooked ],
    [DocumentState.DocumentStateCharged, DocumentStateFromFileBackend.DocumentStateCharged ],
    [DocumentState.DocumentStateApproved, DocumentStateFromFileBackend.DocumentStateApproved ],
    [DocumentState.DocumentStateInRelease, DocumentStateFromFileBackend.DocumentStateInRelease ],
    [DocumentState.DocumentStateReleased, DocumentStateFromFileBackend.DocumentStateReleased ],
    [DocumentState.DocumentStateCanceled, DocumentStateFromFileBackend.DocumentStateCanceled ],
])

export const getDocumentStateFromFILEBACKENDDocumentState = (v: FileTypeFromFileBackend['state']): DocumentState => {
    return fileBackendDocumentStateDocumentState.get(v as unknown as DocumentStateFromFileBackend);
}
export const getFILEBACKENDDocumentStateFromDocumentState = (v: DocumentState): FileTypeFromFileBackend['state'] => {
    return documentStateFileBackendDocumentState.get(v) as unknown as FileTypeFromFileBackend['state'];
}

export const FileEntityDocumentStateNames: Map<DocumentState, string> = new Map<DocumentState, string>([
    [DocumentState.DocumentStateNew, 'neu'],
    [DocumentState.DocumentStateSigned, 'unterschrieben'],
    [DocumentState.DocumentStateEditing, 'in bearbeitung'],
    [DocumentState.DocumentStateSend, 'versendet'],
    [DocumentState.DocumentStateConfirmed, 'bestätigt'],
    [DocumentState.DocumentStateBooked, 'gebucht'],
    [DocumentState.DocumentStateCharged, 'verrechnet'],
    [DocumentState.DocumentStateApproved, 'genehmigt'],
    [DocumentState.DocumentStateInRelease, 'in Freigabe'],
    [DocumentState.DocumentStateReleased, 'freigegeben'],
    [DocumentState.DocumentStateCanceled, 'storniert'],
]);

export const FileEntityDocumentTypeNames: Map<string, string> = new Map<FileEntityDocumentType, string>([
    [FileEntityDocumentType.Invoice, 'Rechnung'],
    [FileEntityDocumentType.Offer, 'Angebot'],
    [FileEntityDocumentType.Contract, 'Vertrag'],
    [FileEntityDocumentType.Order, 'Bestellung'],
    [FileEntityDocumentType.Assignment, 'Auftrag'],
    [FileEntityDocumentType.Delivery_note, 'Lieferschein'],
    [FileEntityDocumentType.Assessment, 'Gutachten'],
    [FileEntityDocumentType.Order_confirmation, 'Auftragsbestätigung'],
    [FileEntityDocumentType.Protocol, 'Protokoll'],
    [FileEntityDocumentType.Audit_report, 'Auditbericht'],
]);
export const NEW_DOCUMENT_DEFAULT_NAME = 'Neues Dokument'
export class FileEntity {
    public static EntityPropertyNames: Map<keyof FileEntity, string> = new Map([
        ['Name', 'Name'],
        ['Description', 'Beschreibung'],
    ])
    public static readonly GqlFields = `
            commission_Ids
            created_At
            customer_Ids
            description
            deleted_At
            event_Ids
            hidden
            shared
            id
            name
            tag_Ids
            versions {
                ${VersionEntity.GqlFields.join(' ')}
            }
            users {
                ${DocumentUserEntity.GqlFields}
            }
            updated_At
            transmission_Ids
            mIME_Type
            folder_Id
            partner_Id
            metaData
            can_edit
            state
            is_email_inline
            checked
            remark
`;

    constructor(
        public Id: number = null,
        public Name: string = null,
        public Description: string = null,
        public Hidden: boolean = null,
        public Shared: boolean = null,
        public MIMEType: string = null,
        public CreatedAt: Date = null,
        public UpdatedAt: Date = null,
        public Versions: VersionEntity[] = null,
        public Users: DocumentUserEntity[] | null = null,
        public EventIds: number[] = null,
        public CustomerId: number = null,
        public ContractId: number = null,
        public VideoId: number = null,
        public TagIds: number[] = null,
        public DeletedAt: Date = null,
        public FolderId: number = null,
        public MIMETypeDescription: string = null,
        public PartnerId: number = null,
        public MetaData: FileMetaData = null,
        public CanEdit: boolean = false,
        public State: DocumentState = null,
        public LinkedDocumentId: number = null,
        public IsEmailInline: boolean = null,
        public Checked: boolean = null,
        public Remark: string = null,
    ) {
    }

    get FileIcon(): IconProp {
        return getFileIconByMimeType(this.MIMEType);
    }

    public Clone(override: Partial<FileEntity> = {}): FileEntity {
        const attr = {...this, ...override};
        return Object.assign(new FileEntity(), attr);
    }

    public GetLastVersion(): VersionEntity {
        if (!this.Versions || !this.Versions[0]) {
            console.error('File Corrupt, has no versions', this);
            return;
        }
        return this.Versions.slice().sort((a, b) => b.Number - a.Number)[0];
    }

    public GetDocumentType(): string {
        switch (this.MetaData.document_type) {
            case 'invoice':
                return 'Rechnung';
            case 'offer':
                return 'Angebot';
            case 'contract':
                return 'Vertrag';
            case 'order':
                return 'Bestellung';
            case 'assignment':
                return 'Auftrag';
            case 'delivery_note':
                return 'Lieferschein';
            case 'assessment':
                return 'Gutachten';
            case 'order_confirmation':
                return 'Auftragsbestätigung';
            case 'protocol':
                return 'Protokoll';
            case 'audit_report':
                return 'Auditbericht';
            case 'blueprint':
                return 'Plan';
            default:
                return 'Dokument';
        }
    }
}
export interface FileTypeFromFileBackend {
    can_edit: boolean;
    commission_ids: number[];
    created_at: string;
    customer_ids: number[];
    deleted_at: string | null;
    description: string;
    event_ids: number[];
    folder_id: number | null;
    hidden: boolean;
    id: number;
    metadata: FileMetaData;
    mime_type: string;
    name: string;
    partner_id: number;
    shared: boolean;
    tag_ids: number[];
    transmission_ids: number[];
    updated_at: string;
    users: DocumentUserType[];
    versions: FileVersionTypeFromFileBackend[];
    state: DocumentStateFromFileBackend;
    linked_document_id: number;
    is_email_inline: boolean;
    checked: boolean;
    remark: string;
}
export function FileEntityFromGateway(res: Document): FileEntity {
    const mimeType = res.MimeType ? mimeTypes.find(m => m.mimeTyp === res.MimeType.split(';')[0])?.description?.replace('-Datei', '') : null;
    let metaData = null;
    if (res.Metadata !== undefined) {
        try {
            metaData = JSON.parse(res.Metadata);
        } catch (e) {
            console.error('Broken Metadata in File with Id = ' + res.Id);
            metaData = null;
        }
    }
    return new FileEntity(
        res.Id && +res.Id,
        res.Name,
        res.Description,
        res.Hidden,
        res.Shared,
        res.MimeType,
        res.CreatedAt ? GetTimeFromTimestamp(+res.CreatedAt) : null,
        res.UpdatedAt ? GetTimeFromTimestamp(+res.UpdatedAt) : null,
        res.Versions.filter(v => !v.DeletedAt).map(v => VersionEntityFromBackend(v, +res.Id)),
        res.Users ? res.Users.map(u => DocumentUserEntityGateway(u)) : null,
        res.EventIds && res.EventIds.map(id => +id),
        res.CustomerIds.length ? +res.CustomerIds[0] : null,
        res.CommissionIds.length ? +res.CommissionIds[0] : null,
        res.TransmissionIds.length ? +res.TransmissionIds[0] : null,
        res.TagIds && res.TagIds.map(id => +id),
        res.DeletedAt ? GetTimeFromTimestamp(+res.DeletedAt) : null,
        res.FolderId && +res.FolderId,
        mimeType,
        res.PartnerId && +res.PartnerId,
        metaData,
        res.CanEdit,
        res.State ? DocumentState[res.State] : null,
        res.LinkedDocumentId && +res.LinkedDocumentId,
        res.IsEmailInline,
        res.Checked,
        res.Remark,
    );
}
export function FileEntityFromFileBackend(res: FileTypeFromFileBackend): FileEntity {

    const mimeType = res.mime_type ? mimeTypes.find(m => m.mimeTyp === res.mime_type.split(';')[0])?.description?.replace('-Datei', '') : null;
    return new FileEntity(
        res.id,
        res.name,
        res.description,
        res.hidden,
        res.shared,
        res.mime_type,
        res.created_at ? BackendDateTimestamp(res.created_at) : null,
        res.updated_at ? BackendDateTimestamp(res.updated_at) : null,
        res.versions.filter(v => !v.deleted_at).map(v => VersionEntityFromFileBackend(v, res.id)),
        res.users ? res.users.map(u => DocumentUserEntityFromBackend(u)) : null,
        res.event_ids,
        res.customer_ids.length ? res.customer_ids[0] : null,
        res.commission_ids.length ? res.commission_ids[0] : null,
        res.transmission_ids.length ? res.transmission_ids[0] : null,
        res.tag_ids,
        res.deleted_at ? BackendDateTimestamp(res.deleted_at) : null,
        res.folder_id,
        mimeType,
        res.partner_id,
        res.metadata,
        res.can_edit,
        res.state ? getDocumentStateFromFILEBACKENDDocumentState(res.state) : null,
        res.linked_document_id,
        res.is_email_inline,
        res.checked,
        res.remark,
    );
}

export const getFileIconByMimeType = (type: string) => {
    if (type) {
        switch (type) {
            case 'application/pdf':
                return 'file-pdf';
            case 'text/csv':
                return 'file-csv';
            case 'text/plain':
            case 'application/rtf':
                return 'file-text';
            case 'application/gzip':
            case 'application/x-tar':
            case 'application/vnd.rar':
            case 'application/zip':
            case 'application/x-7z-compressed':
                return 'file-archive';
            case 'application/vnd.ms-excel':
            case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
                return 'file-excel';
            case 'application/vnd.ms-powerpoint':
            case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
                return 'file-powerpoint';
            case 'application/msword':
            case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
                return 'file-word';
            case 'application/x-sh':
            case 'text/javascript':
            case 'application/x-csh':
            case 'text/html':
            case 'application/x-httpd-php':
            case 'application/java-archive':
                return 'file-code';
        }
        if (type.slice(0, 6) === 'image/') {
            return 'file-image';
        } else if (type.slice(0, 6) === 'audio/' || type === 'application/x-cdf') {
            return 'file-audio';
        } else if (type.slice(0, 6) === 'video/') {
            return 'file-video';
        }
    }
    return 'file';
}

export function FileEntityFromBackend(res: FilesType): FileEntity {
    const mimeType = res.mIME_Type ? mimeTypes.find(m => m.mimeTyp === res.mIME_Type.split(';')[0])?.description : null;

    if (!environment.production && res.mIME_Type) {
        if (!mimeType) {
            console.warn('MIME-Typ nicht gefunden', res.mIME_Type);
        }
    }
    if (!res.versions || !res.versions[0]) {
        console.warn('File Corrupt, has no versions', res);
    }
    let metaData = null;
    if (res.metaData !== undefined) {
        try {
            metaData = JSON.parse(res.metaData);
        } catch (e) {
            console.error('Broken Metadata in File with Id = ' + res.id);
            metaData = null;
        }
    }

    return new FileEntity(
        res.id,
        res.name,
        res.description,
        res.hidden,
        res.shared,
        res.mIME_Type,
        res.created_At ? BackendDateTimestamp(res.created_At) : null,
        res.updated_At ? BackendDateTimestamp(res.updated_At) : null,
        res.versions.filter(v => !v.deleted_At).map(v => VersionEntityFromLegacyBackend(v, res.id)),
        res.users ? res.users.map(u => DocumentUserEntityFromBackend(u)) : null,
        res.event_Ids,
        res.customer_Ids.length ? res.customer_Ids[0] : null,
        res.commission_Ids.length ? res.commission_Ids[0] : null,
        res.transmission_Ids.length ? res.transmission_Ids[0] : null,
        res.tag_Ids,
        res.deleted_At ? BackendDateTimestamp(res.deleted_At) : null,
        res.folder_Id,
        res.mIME_Type && GetFileMimeTypeText(res.mIME_Type),
        res.partner_Id,
        metaData,
        res.can_edit,
        res.state ? getDocumentStateFromGQLDocumentState(res.state) : null,
        null, //todo in gateway einbauen oder das gateway nicht mehr nutzen
        res.is_email_inline,
        );
}

export function GetFileMimeTypeText(input:string|null): string|null {
    return input ? mimeTypesMap.get(input.split(';')[0])?.description?.replace('-Datei', '') : null;
}
export const FileSizeLabels = ['B', 'KB', 'MB', 'GB'];

